<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row class="pa-2" no-gutters>
        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 110px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
              <qr-maker :loading="loading" :svg="svgMade" />
              <v-btn class="btn-download" @click="showDialog = true">
                <v-icon>mdi-progress-download</v-icon>
                {{ $t("download_qr") }}              </v-btn>
            </v-tab-item>

            <v-tab-item>
              <view-shop v-model="cardTexts" />
            </v-tab-item>
          </v-tabs-items>
        </v-col>

        <v-col class="pa-2 px-0" cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <v-row class="row justify-center" no-gutters>
                <v-col class="pa-2" cols="12">
                  <p class="ma-0">محصولات و اطلاعات</p>
                </v-col>
                <v-col class="pa-2" cols="12">
                  <div class="rowinfo">
                    <v-text-field
                      v-model="cardTexts.visitName"
                      :disabled="e6 > 2"
                      append-icon="mdi-pen"
                      class="mt-0 pt-0 contentinfo"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      label="نام فروشگاه آنلاین"
                      outlined
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-cardTexts-visitName`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="نام فروشگاه آنلاین"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <div class="rowinfo justify-start">
                <v-btn
                  :disabled="e6 > 2"
                  class="mb-4"
                  color="third"
                  outlined
                  @click="clearDefaults"
                >
                  <v-icon class="me-2">mdi-delete</v-icon>
                  حذف اطلاعات پیشفرض
                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-cardTexts-clearDefaults`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  label="حذف اطلاعات پیشفرض"
                />
              </div>
              <list-expansion
                v-model="cardTexts"
                :components="specialInfo"
                :data="cardTexts"
                flat
              />

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="e6++"
                  v-text="'ادامه'"
                />
              </div>
            </v-stepper-content>

            <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2"
              >تنظیمات محتوا</v-stepper-step
            >
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
              <list-expansion
                v-model="cardTexts"
                :components="specialInfo2"
                :data="cardTexts"
                flat
              />

              <div class="row mx-auto">
                <div class="col-md-6">
                  <prev-btn :loading="loading" @click="e6--" />
                </div>

                <div class="col-md-6">
                  <next-btn
                    :loading="loading"
                    style="background: #1b8d39"
                    @click="markQr"
                    v-text="'ثبت درخواست'"
                  />
                </div>
              </div>
            </v-stepper-content>
          </v-stepper>
        </v-col>

        <custom-popup
          v-model="showDialog"
          :cons="cons"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-show-download-d`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="دانلود کیوآر"
            />
          </template>
          <v-card class="px-5">
            <download-file
              v-if="showDialog"
              :data="{ theme: '', data: cardTexts }"
              :svg="svgMade"
              :visit-name="cardTexts.visitName"
            />
          </v-card>
        </custom-popup>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import { Bus, debounce, RobotAxios } from "@/main";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import PrevBtn from "@/view/content/fragments/prevBtn";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import DownloadFile from "@/view/pages/qrland/downloadFile";
import ViewShop from "@/view/pages/businessPage/pages/shopPage/viewShop";
import Counter from "@/view/components/Counter";
import Personnel from "@/view/components/Personnel";
import WorkSheet from "@/view/components/WorkSheet";
import Product from "@/view/components/Product/index";

export default {
  name: "editBShopModel",

  props:{
    id:{type:String, default:''},
  },

  components: {
    Counter,
    ViewShop,
    Personnel,
    WorkSheet,
    DownloadFile,
    QrMaker,
    QrManagement,
    QrCustomize,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrAddressField,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "editBShop-b-Model",
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      e6: 1,
      errors: {},
      createdDomain: null,
      createdId: null,
      shortId: null,
      finish: true,
      loading: false,
      showDialog: false,
      specialInfo: [
        {
          name: "bannerSelector",
          value: "",
          title: "آپلود بنر",
          subtitle: "",
          icon: "image",
          model: "banner",
        },
        {
          name: "textCards",
          value: "",
          title: "اطلاعات کاربری",
          subtitle: "",
          icon: "account-outline",
        },
        {
          name: "Product",
          value: "",
          title: "ایجاد محصول",
          subtitle: "",
          icon: "sign-yield",
          model: "product",
          arm: [],
        },
        // {
        //   name: 'specialCategoryManager',
        //   value: '',
        //   title: 'فروش ویژه',
        //   subtitle: '',
        //   icon: 'star-box-outline',
        //   model: 'specialCategories',
        // },
        {
          name: "socialMediaIcons",
          value: "",
          title: "افزودن شبکه های اجتماعی",
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
        },
        { name: "Blog", value: "", title: "بلاگ", subtitle: "", icon: "text" },
        {
          name: "Service",
          value: "",
          title: "خدمات",
          subtitle: "",
          icon: "toolbox-outline",
        },
        {
          name: "Faq",
          value: "",
          title: "سوالات متداول",
          subtitle: "",
          icon: "help",
        },
      ],
      specialInfo2: [
        {
          name: "PicSelector",
          value: "",
          title: "گالری عکس",
          subtitle: "",
          icon: "image",
        },
        {
          name: "VideoGallery",
          value: "",
          title: "گالری ویدئو",
          subtitle: "",
          icon: "video",
        },
        {
          name: "pdfSelector",
          value: "",
          title: "گالری پی دی اف ",
          subtitle: "",
          icon: "file",
        },
        {
          name: "FeedBack",
          value: "",
          title: "بازخورد",
          subtitle: "",
          icon: "reply",
          model: "FeedBack",
        },
        {
          name: "Counter",
          value: "",
          title: "شمارنده معکوس",
          subtitle: "",
          icon: "timer",
          model: "Counter",
        },
        {
          name: "consultation",
          value: "",
          title: "فرم درخواست",
          subtitle: "",
          icon: "list-box-outline",
          model: "consultation",
        },
        {
          name: "ServiceSection",
          value: "",
          title: "ایجاد بخش",
          subtitle: "",
          icon: "post",
          model: "ServiceSection",
        },
        {
          name: "CounterService",
          value: "",
          title: "موفقیت های بدست آمده",
          subtitle: "",
          icon: "post",
          model: "CounterService",
        },
        {
          name: "Personnel",
          value: "",
          title: "اعضای تیم",
          subtitle: "",
          icon: "timer",
          model: "Personnel",
        },
        {
          name: "WorkSheet",
          value: "",
          title: "تایم کاری",
          subtitle: "",
          icon: "timer",
          model: "WorkSheet",
        },
      ],
      eyeStyle: "",
      qrStyle: "",
      qrSize: "",
      dtUrl: null,
      domainId: "",
      cardTexts: {},
      qrShow: 1,
      svgMade: "",
      imageMade: "",
      destinationUrl: "",
    };
  },

  mounted() {
    this.fetchData();

    Bus.$on("socialMedias", (value) => {
      this.cardTexts.socialMedia = value;
    });
  },

  methods: {
    markQr(final = false) {
      this.loading = true;

      let obj = {
        type: "bShop",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify(this.cardTexts),
        qr: JSON.stringify(this.qrDesign),
      };

      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .put(`/qr/template/${this.id}`, {
          qr: obj,
          type: "bShop",
          title: this.cardTexts.visitName,
        })
        .then(({ data }) => {
          this.finish = final;
          this.$toast.success("فروشگاه آنلاین شما با موفقیت ساخته شد.");
          this.$router.replace({ name: "modelsList" });
        })
        .catch(({ response }) => {
          this.errors = response.data.errors;
        })
        .finally(() => (this.loading = false));
    },
    fetchData() {
      this.loading = true;

      this.$api
        .get(`qr/template/${this.id}`)
        .then(({ data }) => {
          let obj = data.data.qr.data ? JSON.parse(data.data.qr.data) : {};

          this.cardTexts = { ...obj };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clearDefaults() {
      this.cardTexts = {
        pdf: undefined,
        banner: undefined,
        blog: undefined,
        service: undefined,
        video_gallery: undefined,
        gallery: undefined,
        photoSlider: false,
        gallerySlider: false,
        isGradient: false,
        visitName: "",
        organizationName: "",
        subOrgan: "",
        userName: "",
        workField: "",
        phoneNumber: [{ number: null }],
        extraFields: [
          {
            icon: "",
            name: "",
            value: "",
          },
        ],
        companyNumber: null,
        email: null,
        fax: null,
        location: null,
        city: null,
        codePostal: null,
        province: null,
        country: null,
        website: null,
        socialMedia: {},
        aboutUs: null,
        copyright: null,
        center: [51.420296, 35.732379],
        coordinates: [51.420296, 35.732379],
        address: null,
        pallete: {},
        textCards: {
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        pdfSelector: {
          title: "گالری پی دی اف",
          description: "توضیحات",
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: false,
          layout: "list",
        },
        Blog: {
          title: "بلاگ",
          description: "توضیحات",
          slide: true,
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        PicSelector: {
          title: "گالری عکس",
          description: "توضیحات",
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: false,
        },
        VideoGallery: {
          title: "گالری ویدئو",
          description: "توضیحات",
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        Faq: {
          title: "سوالات متداول",
          description: "توضیحات",
          design: {
            images: [],
          },
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        Service: {
          title: "خدمات",
          slider: false,
          description:
            "با استراتژیست بازاریابی دیجیتال ما، شرکت خود را در مسیر درست قرار دهید",
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        FeedBack: {
          title: "بازخورد شما",
          description: "",
          sectionColor: {
            backGround: "",
            text: "",
          },
          type: "",
          items: [],
        },
        faqs: [],
        apiKey:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      };
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
